<div class="products-list-links" *ngIf="products.length>0">
    <a [routerLink]="['/']">Productos</a> /
    <a [routerLink]="['/productTypes',products[0].productType.productTypeId]">{{products[0].productType.title}}</a> 
</div>
<div *ngFor="let p of products">
    <article class="productArticle">
        <div class="productHeader">
            <span class="productName">
                <a title={{p.title}} asp-controller="App" asp-action="Shop" aria-haspopup="true">{{p.title}}</a>
            </span>
        </div>
        <figure class="thumbnailContainer">
            <a [routerLink]="['/products',p.productId]">
            <img class="productThumbnail" 
                 [src]="p.images[0].fileName" 
                 [alt]="p.images[0].caption"
                 [title]="p.images[0].caption">
                </a>
        </figure>
        <p class="productPrice">{{p.descriptionShort}}</p>
        <div class="addToCartButton">
            <a [routerLink]="['/products',p.productId]">Mas información</a>
        </div>
    </article>
</div>